import Logger from "@/helpers/logger";
import { getFirstAndLastName } from "@/helpers/session.helper";
import referralService from "@/services/referral/referral.service";

const getCelloScriptSrc = () => {
  if (process.env.VUE_APP_ENV_FLAG === "prod" || process.env.VUE_APP_ENV_FLAG === "preprod") {
    return "https://assets.cello.so/app/latest/cello.js";
  } else {
    return "https://assets.sandbox.cello.so/app/latest/cello.js";
  }
};

const loadCelloScript = async () => {
  return new Promise((resolve, reject) => {
    if (window.cello) {
      resolve(); // If Cello is already loaded, resolve immediately
      return;
    }

    const script = document.createElement("script");
    script.type = "module";
    script.src = getCelloScriptSrc(); // Use the helper function to get the correct URL
    script.async = true;

    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Cello script failed to load"));

    document.head.appendChild(script);
  });
};

// Helper to initialize Cello
export const initializeCello = async (session, productId, token) => {
  const { firstName, lastName } = getFirstAndLastName(session.username);
  try {
    // Load the Cello script
    await loadCelloScript();

    // Initialize Cello after script is loaded
    window.cello = window.cello || { cmd: [] };

    window.cello.cmd.push(async function (cello) {
      try {
        await cello.boot({
          productId,
          token,
          language: "en",
          productUserDetails: {
            firstName: firstName,
            lastName: lastName,
            fullName: session.username,
            email: session.email,
          },
        });
      } catch (error) {
        Logger.error("Failed to boot Cello:", error);
      }
    });
  } catch (error) {
    Logger.error("Failed to load Cello script:", error);
  }
};

export const initializeCelloIntegration = async session => {
  try {
    const response = await referralService.generateCelloToken();
    const { token, productId } = response;

    await initializeCello(session, productId, token);
  } catch (error) {
    Logger.error("Error initializing Cello:", error);
  }
};
